import React from 'react';
import { Link } from 'react-router-dom';

// Trophées palette (mêmes valeurs que HomePage / FaqPage / MentionsLegalesPage / PolitiqueConfidentialitePage)
const NAVY = '#1B1E38';
const CYAN = '#39A8E5';
const BLUE = '#4A71E5';

// Static content extracted from "CGU IP 2026 V2.docx"
// (version en vigueur au 20/05/2026). Edits go directly here.

const EFFECTIVE_DATE = '20/05/2026';

export default function ConditionsUtilisationPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      {/* ===== Top bar ===== */}
      <header style={{
        background: NAVY, color: 'white', padding: '14px 32px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        position: 'sticky', top: 0, zIndex: 100,
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'baseline', gap: 8, textDecoration: 'none', color: 'white' }}>
          <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 800, fontSize: 18, letterSpacing: '-0.3px' }}>Plateforme ISI</span>
          <span style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: 13, color: CYAN }}>by Paradoxe.ai for LBP AM</span>
        </Link>
        <nav style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <Link to="/faq" style={navLinkStyle}>FAQ</Link>
          <a href="mailto:contact.tropheeslbpam@investance-partners.com" style={navLinkStyle}>Nous contacter</a>
          <Link to="/login" style={navLinkStyle}>Se connecter</Link>
          <Link to="/register" style={{ ...navLinkStyle, color: 'white', background: BLUE, border: `1px solid ${BLUE}` }}>Créer un compte</Link>
        </nav>
      </header>

      {/* ===== Hero ===== */}
      <section style={{
        background: `linear-gradient(180deg, ${NAVY} 0%, #2A2E4E 100%)`,
        color: 'white', padding: '56px 32px 40px',
      }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <p style={{ fontSize: 13, color: CYAN, fontWeight: 600, letterSpacing: 1.2, marginBottom: 12, textTransform: 'uppercase' }}>
            Conditions d'utilisation
          </p>
          <h1 style={{ fontFamily: 'Lato, sans-serif', fontSize: 38, fontWeight: 800, lineHeight: 1.15, marginBottom: 12, marginTop: 0 }}>
            Conditions générales d'utilisation
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.55, color: 'rgba(255,255,255,0.85)', maxWidth: 720, marginBottom: 0 }}>
            Plateforme Trophées de l'innovation 2026
            <br />
            <span style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.65)' }}>
              Investance Partners — Version en vigueur au {EFFECTIVE_DATE}.
            </span>
          </p>
        </div>
      </section>

      {/* ===== Body ===== */}
      <section style={{ padding: '48px 32px 64px', background: '#FAFBFD' }}>
        <div style={{ maxWidth: 880, margin: '0 auto' }}>

          {/* Intro callout (table 0 in source docx) */}
          <Callout>
            En accédant à la plateforme et en utilisant ses fonctionnalités,
            l'Utilisateur reconnaît avoir lu, compris et accepté sans réserve
            les présentes Conditions générales d'utilisation. Cette acceptation
            est matérialisée par une case à cocher obligatoire lors de la
            création du compte. Toute adhésion sous réserve est réputée nulle
            et non avenue.
          </Callout>

          {/* §1 */}
          <Section id={1} title="Principes clés">
            <P>
              Les présentes CGU fixent les modalités et conditions par lesquelles Investance Partners met la
              plateforme Trophées de l'innovation 2026 à la disposition de l'Utilisateur, et par lesquelles
              l'Utilisateur peut accéder à cette plateforme et utiliser ses fonctionnalités.
            </P>
            <P>
              L'accès à la plateforme est gratuit, hors fourniture d'accès internet dont les coûts sont
              facturés directement par les opérateurs.
            </P>
          </Section>

          {/* §2 */}
          <Section id={2} title="À propos de nous">
            <P>
              <strong>Investance Partners</strong>, société anonyme au capital de 113 950 euros, dont le
              siège social est situé au 31 rue Saint-Augustin, 75002 Paris, immatriculée au RCS de Paris
              sous le numéro 435 257 175.
            </P>
            <Def label="Directeur de la publication">Luc-Sorel OM, Directeur Général.</Def>
            <Def label="Référent RGPD" href="mailto:rgpd@investance-partners.com">rgpd@investance-partners.com</Def>
            <Def label="Contact" href="mailto:contact.lbpam@investance-partners.com">contact.lbpam@investance-partners.com</Def>
          </Section>

          {/* §3 */}
          <Section id={3} title="Définitions">
            <dl style={dlStyle}>
              <Term name="CGU" desc="le présent document et ses éventuelles annexes." />
              <Term name="Plateforme" desc="l'ensemble des services fournis par Investance Partners dans le cadre des Trophées de l'innovation 2026." />
              <Term name="Utilisateur" desc="toute personne physique ou morale accédant à la plateforme." />
              <Term name="Candidat" desc="toute entreprise ayant créé un compte et soumis un dossier de candidature." />
              <Term name="Compte" desc="l'espace personnel créé par l'Utilisateur permettant l'accès aux fonctionnalités réservées aux Candidats." />
              <Term name="Dossier de candidature" desc="l'ensemble des informations et documents transmis par le Candidat via la plateforme." />
              <Term name="Identifiants" desc="l'adresse e-mail et le mot de passe choisis lors de la création du Compte." />
            </dl>
          </Section>

          {/* §4 */}
          <Section id={4} title="Acceptation des CGU">
            <P>
              La connexion et l'utilisation de la plateforme impliquent l'acceptation intégrale et sans
              réserve des présentes CGU. L'Utilisateur qui refuse les CGU ne doit pas accéder à la plateforme.
            </P>
            <P>
              Les CGU en vigueur sont accessibles et imprimables à tout moment sur la plateforme.
              L'Utilisateur est réputé accepter la dernière version à chaque nouvelle connexion.
            </P>
          </Section>

          {/* §5 */}
          <Section id={5} title="Création de compte et espace personnel">
            <SubTitle>5.1 Conditions de création</SubTitle>
            <P>L'accès aux fonctionnalités de candidature est subordonné à la création d'un Compte.</P>
            <P style={{ marginBottom: 4 }}>Pour créer un Compte, l'Utilisateur doit :</P>
            <Bullets items={[
              "être le représentant légal ou un fondateur habilité d'une entreprise éligible aux Trophées de l'innovation 2026 ;",
              'fournir une adresse e-mail professionnelle valide et un mot de passe sécurisé (minimum 8 caractères, incluant majuscules, minuscules et caractères spéciaux) ;',
              "renseigner les informations relatives à l'entreprise candidate de manière exacte, complète et sincère ;",
              "accepter expressément les présentes CGU, la politique de confidentialité et la notice d'information RGPD en cochant les cases prévues à cet effet.",
            ]} />
            <P>
              Investance Partners se réserve le droit de refuser ou de supprimer tout Compte dont les
              informations seraient inexactes, incomplètes ou frauduleuses.
            </P>

            <SubTitle>5.2 Sécurité et confidentialité du Compte</SubTitle>
            <P>
              Chaque Utilisateur ne peut créer qu'un seul Compte par entreprise candidate. L'Utilisateur
              est seul responsable de la confidentialité de ses Identifiants. Il s'engage à :
            </P>
            <Bullets items={[
              'maintenir strictement le caractère confidentiel de ses Identifiants et à ne pas les communiquer à des tiers ;',
              'prendre toutes les mesures nécessaires pour préserver la sécurité de son Compte ;',
              <>informer immédiatement Investance Partners de toute utilisation non autorisée de son Compte : <a href="mailto:contact@investance-partners.com" className="ml-link">contact@investance-partners.com</a>.</>,
            ]} />
            <P>
              Toute connexion effectuée depuis le Compte sera présumée effectuée par l'Utilisateur.
              Investance Partners ne pourra être tenu responsable de dommages résultant de la divulgation
              des Identifiants.
            </P>

            <SubTitle>5.3 Clôture du Compte</SubTitle>
            <P>
              L'Utilisateur peut demander la clôture de son Compte à tout moment à{' '}
              <a href="mailto:contact@investance-partners.com" className="ml-link">contact@investance-partners.com</a>,
              sous réserve de ne pas avoir de dossier en cours de traitement.
            </P>
            <P>
              En cas de violation des présentes CGU par l'Utilisateur, Investance Partners adresse une mise
              en demeure par e-mail, restée sans effet pendant un délai raisonnable de <strong>quinze (15) jours</strong>,
              avant de procéder à la suspension ou à la clôture du Compte. Toutefois, en cas de manquement
              grave (fraude, usurpation d'identité, atteinte à la sécurité de la plateforme, soumission de
              contenus illicites, ou tout manquement listé au §7 portant atteinte aux droits de tiers ou à
              l'ordre public), Investance Partners se réserve le droit de procéder à la suspension ou à la
              clôture immédiate du Compte, sans préavis ni indemnité, et sans préjudice de tout recours.
            </P>
          </Section>

          {/* §6 */}
          <Section id={6} title="Droits de l'Utilisateur">
            <P>Dans le cadre de l'utilisation de la plateforme, l'Utilisateur bénéficie des droits suivants :</P>
            <Bullets items={[
              "accéder à son Compte et à son dossier de candidature pendant la période d'ouverture de la plateforme ;",
              <>modifier les informations de son dossier dans les délais et conditions précisés dans le <Link to="/reglement" className="ml-link">règlement officiel</Link>, qui dispose d'une prééminence sur le présent document ;</>,
              'demander la suppression de son Compte et de ses données dans les conditions prévues par la politique de confidentialité ;',
              'exercer ses droits RGPD (accès, rectification, effacement, limitation, opposition, portabilité) auprès de la référente RGPD ;',
              "être informé de toute modification substantielle des CGU préalablement à leur entrée en vigueur ;",
              "rester propriétaire de l'ensemble des informations et innovations transmises dans son dossier de candidature.",
            ]} />
          </Section>

          {/* §7 */}
          <Section id={7} title="Obligations de l'Utilisateur">
            <P>
              L'Utilisateur s'engage à utiliser la plateforme conformément à sa destination et à la
              réglementation applicable. Le non-respect de ces obligations est susceptible d'engager sa
              responsabilité civile et/ou pénale.
            </P>
            <P style={{ marginBottom: 4 }}>Il est notamment interdit à l'Utilisateur de :</P>
            <Bullets items={[
              "transmettre des informations inexactes, incomplètes ou de nature à induire en erreur le jury ou l'équipe organisatrice ;",
              "usurper l'identité d'une autre personne physique ou morale ;",
              "utiliser la plateforme à des fins autres que la candidature aux Trophées de l'innovation 2026 ;",
              "tenter de nuire au bon fonctionnement de la plateforme, notamment par l'introduction de virus, codes malveillants, ou par toute tentative d'intrusion ou de surcharge des serveurs ;",
              "contourner, désactiver ou altérer les mesures de sécurité mises en place ;",
              "collecter ou extraire des données relatives à d'autres Utilisateurs ou Candidats ;",
              'reproduire ou exploiter à des fins commerciales tout ou partie du contenu de la plateforme ;',
              "diffuser des contenus illicites, offensants, diffamatoires ou contraires à l'ordre public ;",
              'soumettre plusieurs dossiers de candidature pour une même entreprise.',
            ]} />
            <P>
              Tout manquement pourra entraîner la suspension immédiate ou la clôture définitive du Compte
              et la disqualification du dossier de candidature, sans préjudice de tout recours judiciaire.
              Avant toute mesure de disqualification d'un dossier de candidature, l'Utilisateur concerné
              est informé par e-mail des griefs retenus à son encontre et dispose d'un délai de
              <strong> sept (7) jours</strong> pour faire valoir ses observations écrites, sauf en cas de
              manquement grave portant une atteinte immédiate et irréversible à la sécurité de la plateforme,
              à l'intégrité du concours ou aux droits de tiers.
            </P>
          </Section>

          {/* §8 */}
          <Section id={8} title="Nature des informations diffusées">
            <P>
              Le contenu de la plateforme est à usage informatif dans le cadre des Trophées de l'innovation
              2026. Les informations qui y figurent ne constituent pas une offre au public, une sollicitation
              ou un démarchage de la part d'Investance Partners.
            </P>
          </Section>

          {/* §9 */}
          <Section id={9} title="Propriété intellectuelle">
            <P>
              Le contenu de la plateforme (dénominations, marques, logos, textes, graphiques, données,
              bases de données, structure du site) est protégé par le droit de la propriété intellectuelle.
              Toute reproduction sans autorisation préalable et écrite d'Investance Partners est
              strictement prohibée.
            </P>
            <P>
              Le Candidat reste propriétaire de l'ensemble des informations et innovations transmises dans
              son dossier. La transmission du dossier ne confère à Investance Partners aucun droit de
              propriété intellectuelle sur les éléments transmis.
            </P>
          </Section>

          {/* §10 */}
          <Section id={10} title="Données à caractère personnel">
            <P>
              Le traitement de vos données personnelles est régi par la{' '}
              <Link to="/politique-confidentialite" className="ml-link">politique de confidentialité</Link>{' '}
              et la notice d'information candidats, accessibles sur la plateforme. Le contact RGPD
              Investance Partners est :{' '}
              <a href="mailto:rgpd@investance-partners.com" className="ml-link">rgpd@investance-partners.com</a>.
            </P>
            <P>
              Les contacts du responsable de traitement sont précisés dans la politique de confidentialité
              de la plateforme.
            </P>
          </Section>

          {/* §11 */}
          <Section id={11} title="Cookies">
            <P>
              La plateforme <strong>ne dépose aucun cookie</strong> sur le terminal de l'Utilisateur. Les
              fonctionnalités d'authentification et de mémorisation des préférences reposent exclusivement
              sur le <em>localStorage</em> du navigateur, dans des conditions strictement fonctionnelles
              bénéficiant de l'exemption de consentement prévue par la recommandation « cookies et autres
              traceurs » de la CNIL. Aucun bandeau de consentement n'est requis. Le détail des mécanismes
              de stockage utilisés et des ressources tierces éventuellement chargées par le navigateur
              figure dans la{' '}
              <Link to="/politique-confidentialite" className="ml-link">politique de confidentialité</Link>{' '}
              accessible sur la plateforme.
            </P>
          </Section>

          {/* §12 */}
          <Section id={12} title="Garanties et limitation de responsabilité">
            <P>
              L'utilisation de la plateforme est soumise à une obligation de moyens. Investance Partners
              met en œuvre les diligences raisonnables pour assurer le bon fonctionnement, la disponibilité
              et la sécurité de la plateforme, sans toutefois garantir une disponibilité ininterrompue ou
              exempte d'erreur. Investance Partners ne peut être tenu responsable en cas de modification,
              suspension ou interruption de la plateforme, d'indisponibilité résultant d'un opérateur de
              télécommunications, d'erreur de transmission ou de défaillance matérielle.
            </P>
            <P>
              En aucun cas la responsabilité d'Investance Partners ne pourra être engagée pour des dommages
              indirects résultant de l'utilisation de la plateforme, sauf en cas de faute lourde ou
              dolosive d'Investance Partners.
            </P>
            <P>
              Investance Partners ne saurait être tenu pour responsable de l'inexécution ou du retard
              d'exécution de l'une quelconque de ses obligations en cas de survenance d'un événement de
              <strong> force majeure</strong>, au sens de l'article 1218 du Code civil. Sont notamment
              considérés comme tels, sans que cette liste soit limitative : les catastrophes naturelles,
              les actes de guerre, de terrorisme, les attaques informatiques d'ampleur, les pannes ou
              interruptions majeures des réseaux de télécommunications, ainsi que toute décision d'une
              autorité publique faisant obstacle à l'exécution des présentes.
            </P>
          </Section>

          {/* §13 */}
          <Section id={13} title="Liens hypertextes">
            <P>
              La plateforme peut contenir des liens vers des sites de partenaires ou de tiers. Investance
              Partners n'exerce aucun contrôle sur ces sites et n'assume aucune responsabilité quant à
              leur contenu ou disponibilité.
            </P>
          </Section>

          {/* §14 */}
          <Section id={14} title="Modification des CGU">
            <P>
              Les CGU peuvent être modifiées à tout moment par Investance Partners. En cas de modification
              substantielle, les Utilisateurs disposant d'un Compte seront informés par e-mail avec un
              préavis raisonnable. L'Utilisateur qui refuse les nouvelles CGU peut demander la clôture
              de son Compte.
            </P>
          </Section>

          {/* §15 */}
          <Section id={15} title="Réclamation et médiation commerciale">
            <P>
              Pour toute réclamation, l'Utilisateur peut contacter Investance Partners par e-mail à{' '}
              <a href="mailto:contact.lbpam@investance-partners.com" className="ml-link">contact.lbpam@investance-partners.com</a>{' '}
              ou par courrier au 31 rue Saint-Augustin, 75002 Paris.
            </P>
            <P>
              Les Parties s'engagent à tenter de résoudre tout litige à l'amiable dans un délai de
              trente (30) jours. En cas d'échec, et sans préjudice de tout recours judiciaire, les Parties
              peuvent recourir aux dispositifs de médiation suivants : lorsque le litige oppose Investance
              Partners à un Candidat agissant en qualité de personne morale, à la médiation commerciale du
              Centre de Médiation et d'Arbitrage de Paris (CMAP —{' '}
              <a href="https://www.cmap.fr" target="_blank" rel="noopener noreferrer" className="ml-link">www.cmap.fr</a>).
            </P>
          </Section>

          {/* §16 */}
          <Section id={16} title="Droit applicable et juridiction">
            <P>
              Les présentes CGU sont régies par le droit français. En cas de litige non résolu à
              l'amiable, les tribunaux de Paris seront seuls compétents.
            </P>
          </Section>

          {/* Effective + last-update line */}
          <div style={{
            marginTop: 28, padding: '20px 24px', borderRadius: 10,
            background: 'white', border: '1px solid #E3E7F2',
            color: '#555', fontSize: 13.5, lineHeight: 1.7, textAlign: 'center',
          }}>
            <div>Les présentes CGU sont entrées en vigueur le : <strong style={{ color: NAVY }}>{EFFECTIVE_DATE}</strong></div>
            <div style={{ marginTop: 10, fontSize: 12, color: '#888' }}>
              Investance Partners — 31 rue Saint-Augustin, 75002 Paris — RCS Paris 435 257 175
            </div>
          </div>

          {/* CTA */}
          <div style={{ marginTop: 32, textAlign: 'center', display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" style={{
              display: 'inline-block', padding: '10px 24px',
              border: `1px solid ${BLUE}`, color: BLUE,
              borderRadius: 999, textDecoration: 'none',
              fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: 14,
            }}>← Retour à l'accueil</Link>
            <Link to="/mentions-legales" style={ctaSecondaryStyle}>Mentions légales</Link>
            <Link to="/politique-confidentialite" style={ctaSecondaryStyle}>Politique de confidentialité</Link>
            <Link to="/reglement" style={ctaSecondaryStyle}>Règlement des trophées de l'innovation 2026</Link>
          </div>
        </div>
      </section>

      {/* Inline styles for the ml-link class (shared with other legal pages) */}
      <style>{`
        .ml-link {
          color: ${BLUE};
          text-decoration: none;
          border-bottom: 1px solid transparent;
          transition: color 0.15s, border-color 0.15s;
          word-break: break-word;
        }
        .ml-link:hover { color: ${CYAN}; border-bottom-color: ${CYAN}; }
        .ml-link:focus-visible {
          outline: 2px solid ${CYAN};
          outline-offset: 2px;
          border-radius: 2px;
        }
      `}</style>
    </div>
  );
}

// ===== Small typed building blocks (kept consistent with PolitiqueConfidentialitePage) =====

function Section({ id, title, children }) {
  return (
    <article style={{
      background: 'white', borderRadius: 14,
      padding: '28px 32px', marginBottom: 18,
      boxShadow: '0 1px 3px rgba(27,30,56,0.06), 0 0 0 1px rgba(27,30,56,0.04)',
    }}>
      <h2 style={{
        fontFamily: 'Lato, sans-serif', fontSize: 20, fontWeight: 700,
        color: NAVY, marginTop: 0, marginBottom: 16,
        display: 'flex', alignItems: 'baseline', gap: 10,
      }}>
        <span style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 28, height: 28, borderRadius: '50%',
          background: BLUE, color: 'white', fontSize: 13, fontWeight: 700,
          flexShrink: 0,
        }}>{id}</span>
        {title}
      </h2>
      {children}
    </article>
  );
}

function SubTitle({ children }) {
  return (
    <h3 style={{
      fontFamily: 'Lato, sans-serif', fontSize: 15.5, fontWeight: 700,
      color: NAVY, margin: '20px 0 10px',
    }}>{children}</h3>
  );
}

function P({ children, style }) {
  return (
    <p style={{ fontSize: 14.5, lineHeight: 1.7, color: '#333', margin: '0 0 12px', ...style }}>
      {children}
    </p>
  );
}

function Def({ label, children, href }) {
  return (
    <p style={{ fontSize: 14, lineHeight: 1.6, color: '#333', margin: '4px 0' }}>
      <strong style={{ color: NAVY }}>{label} :</strong>{' '}
      {href ? (
        <a href={href} className="ml-link"
           {...(href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
          {children}
        </a>
      ) : children}
    </p>
  );
}

// §3 definitions list — term/description pairs with a subtle vertical rhythm
function Term({ name, desc }) {
  return (
    <>
      <dt style={{ fontWeight: 700, color: NAVY, fontSize: 14, marginTop: 8 }}>« {name} »</dt>
      <dd style={{ margin: '2px 0 0 0', color: '#333', fontSize: 14, lineHeight: 1.6 }}>{desc}</dd>
    </>
  );
}

function Bullets({ items }) {
  return (
    <ul style={{ margin: '6px 0 14px 0', paddingLeft: 22, lineHeight: 1.7, color: '#333', fontSize: 14.5 }}>
      {items.map((it, i) => <li key={i} style={{ marginBottom: 4 }}>{it}</li>)}
    </ul>
  );
}

function Callout({ children, small }) {
  return (
    <div style={{
      background: '#F0F4FB', borderLeft: `4px solid ${BLUE}`,
      padding: small ? '12px 16px' : '14px 18px',
      borderRadius: 8, margin: small ? '12px 0' : '0 0 18px',
      color: NAVY, fontSize: small ? 13.5 : 14, lineHeight: 1.6,
    }}>{children}</div>
  );
}

// ===== Shared styles =====
const navLinkStyle = {
  fontFamily: 'Lato, sans-serif', fontSize: 14, fontWeight: 600,
  padding: '9px 18px', borderRadius: 999, textDecoration: 'none',
  color: 'rgba(255,255,255,0.85)', whiteSpace: 'nowrap',
};

const dlStyle = { margin: '0', padding: 0 };

const ctaSecondaryStyle = {
  display: 'inline-block', padding: '10px 24px',
  border: `1px solid ${NAVY}`, color: NAVY,
  borderRadius: 999, textDecoration: 'none',
  fontFamily: 'Lato, sans-serif', fontWeight: 600, fontSize: 14,
};
